import Constant from '@/const';
import axios from 'axios';

const getCpptById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/inpatient/cppt/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getCpptById;
